<!--Page：Header+Block-->
<template>
  <div class="v-page">
    <v-header  :menu-val="pageVal.pageNav" v-if="pageVal.pageNav"></v-header>
    <div v-for="(item,index) in pageVal.blocks" :key="index">
      <v-block :block-val="item.block"  v-if="item.block"></v-block>
    </div>
    <v-footer  v-if="pageVal.pageNav"></v-footer>
  </div>
</template>

<script>
import block from "@/components/block"
import header from "@/components/header"
import footer from "@/components/footer"
export default {
  name: 'v-page',
  components:{
    "v-header":header,//头部组件
    "v-block":block,//块组件
    "v-footer":footer,//尾部组件
  },
  props: {
      pageVal: null //这样可以指定传入的类型，如果类型不对，会警告
  },
  data () {
    return {
      cotainer:"full",//full center 默认充满 （非必填）
      navStatus:true,
    }
  },
  created(){
    // var that = this;
    document.title ="北京软通动力教育科技有限公司";
  },
  methods:{
    // linkUrl(){
    //   // this.$router.push({'name':'product'});
    // },
    //转换样式
    getAttr(_attr,_type){
      var data={};
      if(_attr!==''){
        data=JSON.parse(_attr);
        return data.[_type];
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>

</style>
